import React, { useState } from "react";
import Joi from "joi-browser";
import SecurityQuestion from "./SecurityQuestion";
import ThankYou from "./ThankYou";
import useForm from "../../app/hooks/useForm";
import useControls from "../../app/hooks/useControls";
import {
  useVerifyUserByEmailMutation,
  useLazySendSecurityCodeToEmailQuery,
  useLazySendSecurityCodeToPhoneQuery,
  useLazyVerifySecurityCodeQuery,
} from "../../app/store/authApiSlice";

const ForgotUserName = ({ handleBackUser, forgotType, urlData }) => {
  const [securityQuestion, setSecurityQuestion] = useState(false);
  const [userNameBlock, setUserNameBlock] = useState(true);
  const [secQuestion, setSecQuestion] = useState("");
  const [emailAuth, setEmailAuth] = useState(false);
  const [phoneAuth, setPhoneAuth] = useState(false);
  const [securityAuth, setSecurityAuth] = useState(false);
  const [thankYou, setThankYou] = useState(false);
  const [questionAuth, setQuestionAuth] = useState(false);
  const [sendCodeBtnLoding, setSendCodeBtnLoding] = useState(false);
  const [verifyBtnLoding, setVerifyBtnLoding] = useState(false);
  const [reSendCodeBtnLoding, setReSendCodeBtnLoding] = useState(false);
  const [reSendCodeMsg, setReSendCodeMsg] = useState(false);

  const [verifyUserByEmail] = useVerifyUserByEmailMutation();
  const [sendSecurityCodeToEmail] = useLazySendSecurityCodeToEmailQuery();
  const [sendSecurityCodeToPhone] = useLazySendSecurityCodeToPhoneQuery();
  const [verifySecurityCode] = useLazyVerifySecurityCodeQuery();

  const schema = {
    //firstName: Joi.string().required().label("First Name"),
    //lastName: Joi.string().required().label("Last Name"),
    email: Joi.string().email().required().label("Email"),
    //userType: Joi.string().required().label("User Type"),
  };

  const handleSecurityQuestion = (question) => {
    setSecurityQuestion(true);
    setUserNameBlock(false);
    setSecQuestion(question);
    setQuestionAuth(false);
  };

  const doSubmit = async () => {
    const { data: result } = await verifyUserByEmail(stateData);
    //console.log(result);
    if (result === "") {
      setStateErrors({ ...stateErrors, email: "Invalid Details" });
    } else if (result.length > 0) {
      handleSecurityQuestion(result);
    } else {
      setStateErrors({ ...stateErrors, email: "Security question not set!" });
    }
  };

  const handleEmailAuth = () => {
    setEmailAuth(true);
    setPhoneAuth(false);
    setStateErrors({});
    setStateData({});
  };
  const handlePhoneAuth = () => {
    setPhoneAuth(true);
    setEmailAuth(false);
    setStateErrors({});
    setStateData({});
  };

  const handleSecurityCode = async () => {
    const data = stateData;
    const errors = { ...stateErrors };
    if (
      forgotType !== "Username" &&
      (data["userName"] === "" || data["userName"] === undefined)
    ) {
      if (emailAuth) errors["userName"] = "Please enter username";
      if (phoneAuth) errors["phone"] = "Please enter username";
      setStateErrors(errors);
    } else if (
      data["email"] === "" ||
      (data["email"] === undefined && emailAuth)
    ) {
      errors["email"] = "Please enter email";
      setStateErrors(errors);
    } else if (
      data["phone"] === "" ||
      (data["phone"] === undefined && phoneAuth)
    ) {
    } else {
      setSendCodeBtnLoding(true);
      if (emailAuth && !phoneAuth) {
        const { data: result } = await sendSecurityCodeToEmail({
          username: data["userName"],
          email: data["email"],
          type: forgotType,
        });
        if (result === "fail") {
          errors["email"] = "Invalid Details";
          setStateErrors(errors);
          setSendCodeBtnLoding(false);
        } else {
          setSecurityAuth(true);
          setSendCodeBtnLoding(false);
          setStateErrors({});
        }
      }

      if (phoneAuth && !emailAuth) {
        const { data: result } = await sendSecurityCodeToPhone({
          username: data["userName"],
          phone: data["phone"],
          type: forgotType,
        });
        if (result === "fail") {
          errors["phone"] = "Invalid Details";
          setStateErrors(errors);
          setSendCodeBtnLoding(false);
        } else {
          setSecurityAuth(true);
          setSendCodeBtnLoding(false);
        }
      }
    }
  };

  const handleVerifyCode = async () => {
    const data = stateData;
    const errors = { ...stateErrors };
    if (data["securityCode"] === "" || data["securityCode"] === undefined) {
      errors["securityCode"] = "Please enter security code";
      setStateErrors(errors);
    } else {
      setVerifyBtnLoding(true);
      let email = data["email"];
      if (phoneAuth) email = data["phone"];
      const { data: result } = await verifySecurityCode({
        email,
        code: data["securityCode"],
        type: forgotType,
      });
      if (result === "success") {
        setThankYou(true);
        setUserNameBlock(false);
        setVerifyBtnLoding(false);
      } else {
        errors["securityCode"] = "Invalid Code";
        setStateErrors(errors);
        setVerifyBtnLoding(false);
      }
    }
  };

  const handleQuestionAuth = () => {
    setQuestionAuth(true);
    setEmailAuth(false);
    setPhoneAuth(false);
    setStateData({});
    setStateErrors({});
  };

  const handleQuestionBack = () => {
    setSecurityQuestion(false);
    setQuestionAuth(true);
    setUserNameBlock(true);
  };

  const handleBack = () => {
    if (!securityAuth && emailAuth) {
      setEmailAuth(!emailAuth);
    }
    if (!securityAuth && phoneAuth) {
      setPhoneAuth(!phoneAuth);
    }
    if (!securityAuth && questionAuth) {
      setQuestionAuth(!questionAuth);
    }

    if (emailAuth || phoneAuth || questionAuth) setSecurityAuth(false);
    else handleBackUser();
  };

  const handleResendCode = async () => {
    const data = stateData;
    const errors = { ...stateErrors };
    setReSendCodeBtnLoding(true);
    if (emailAuth && !phoneAuth) {
      const { data: result } = await sendSecurityCodeToEmail({
        username: data["userName"],
        email: data["email"],
        type: forgotType,
      });
      if (result === "fail") {
        errors["email"] = "Invalid Details";
        setStateErrors(errors);
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(false);
      } else {
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(true);
      }
    }

    if (phoneAuth && !emailAuth) {
      const { data: result } = await sendSecurityCodeToPhone({
        username: data["userName"],
        phone: data["phone"],
        type: forgotType,
      });
      if (result === "fail") {
        errors["phone"] = "Invalid Details";
        setStateErrors(errors);
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(false);
      } else {
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(true);
      }
    }
  };

  const {
    stateData,
    setStateData,
    stateErrors,
    setStateErrors,
    handleChange,
    validate,
    handleSubmit,
  } = useForm(schema, doSubmit);

  const { renderInput } = useControls(
    stateData,
    stateErrors,
    handleChange,
    schema
  );

  return (
    <React.Fragment>
      {userNameBlock && (
        <div className="row">
          <div className="col-md-12 mb-3">
            <button
              className="btn btn-link btn-sm login-back"
              onClick={handleBack}
            >
              <i className="fa fa-arrow-left" aria-hidden="true"></i>
              Back
            </button>
          </div>

          {questionAuth && (
            <React.Fragment>
              {/* <div className="col-md-12">
                {renderInput("firstName", "Enter Your First Name")}
              </div>
              <div className="col-md-12">
                {renderInput("lastName", "Enter Your Last Name")}
              </div> */}
              <div className="col-md-12">
                {renderInput("email", "Enter Your Registered Email")}
              </div>
              <div className="col-md-12">
                <button
                  className="btn btn-outline-default w-100"
                  disabled={!!validate()}
                  onClick={handleSubmit}
                >
                  <i className="fa fa-arrow-right mr-2" aria-hidden="true"></i>
                  Next
                </button>
              </div>
            </React.Fragment>
          )}
          {!emailAuth && !phoneAuth && !questionAuth && (
            <div className="col-md-12 d-flex flex-column align-items-center text-center">
              <h2 className="mb-3">Verify Your Identity</h2>
              <p>
                You will now be required to enter One-Time Security Code to
                verify your identity.
              </p>
              <br />
              <p>How would you like to receive the code?</p>
              <br />
              <div className="d-flex flex-row align-items-center text-center ">
                <button
                  className="btn btn-outline-default mr-2"
                  onClick={handleEmailAuth}
                >
                  <i className="fa fa-envelope mr-2" aria-hidden="true"></i>
                  Send To My Email
                </button>
                {/* <button
                  className="btn btn-outline-default mr-2"
                  onClick={handlePhoneAuth}
                >
                  Text To My Mobile
                </button> */}
                <button
                  className="btn btn-outline-default mr-2"
                  onClick={handleQuestionAuth}
                >
                  <i className="fa fa-question-circle mr-2" aria-hidden="true"></i>
                  Security Question
                </button>
              </div>
            </div>
          )}
          {forgotType !== "Username" && (emailAuth || phoneAuth) && (
            <div className="col-md-12">
              {renderInput("userName", "Enter Your Username")}
            </div>
          )}
          {emailAuth && (
            <div className="col-md-12">
              {renderInput("email", "Enter Your Registered Email")}
            </div>
          )}
          {/* {phoneAuth && (
            <div className="col-md-12">
              {renderInput(
                "phone",
                "Enter Your Registered Mobile Number"
              )}
            </div>
          )} */}
          {securityAuth && (
            <div className="col-md-12">
              {renderInput(
                "securityCode",
                "Enter Your Code Below To Continue"
              )}
            </div>
          )}
          {(emailAuth || phoneAuth) && !securityAuth && (
            <div className="col-md-12 d-flex flex-row justify-content-center align-items-center text-center">
              <button
                className="btn btn-outline-default"
                disabled={sendCodeBtnLoding}
                onClick={handleSecurityCode}
              >
                {sendCodeBtnLoding ? (
                  <i className="fa fa-refresh fa-spin mr-2"></i>
                ) : (
                  <i className="fa fa-paper-plane mr-2" aria-hidden="true"></i>
                )}
                Send Security Code To My {emailAuth && "email"}{" "}
                {phoneAuth && "mobile"}
              </button>
            </div>
          )}
          {securityAuth && (
            <div className="col-md-12 d-flex flex-column align-items-center">
              <button
                className="btn btn-outline-default"
                disabled={verifyBtnLoding}
                onClick={handleVerifyCode}
              >
                {verifyBtnLoding ? (
                  <i className="fa fa-refresh fa-spin mr-2"></i>
                ) : (
                  <i className="fa fa-check mr-2" aria-hidden="true"></i>
                )}
                Verify
              </button>
              {/* <br />
              <br /> */}
              <p>Didn't receive the code?</p>
              <button
                className="btn btn-sm btn-link pl-0"
                disabled={reSendCodeBtnLoding}
                onClick={handleResendCode}
              >
                {reSendCodeBtnLoding && (
                  <i className="fa fa-refresh fa-spin mr-2"></i>
                )}
                Resend Code
              </button>
              {reSendCodeMsg && (
                <span className="text-red">
                  Security Code Sent Successfully
                </span>
              )}
            </div>
          )}
        </div>
      )}
      {thankYou && (
        <ThankYou forgotType={forgotType} urlData={urlData}></ThankYou>
      )}
      {securityQuestion && (
        <SecurityQuestion
          handleQuestionBack={handleQuestionBack}
          secQuestion={secQuestion}
          userType={stateData["userType"]}
          forgotType={forgotType}
          securityQuestion={securityQuestion}
          urlData={urlData}
        ></SecurityQuestion>
      )}
    </React.Fragment>
  );
};

export default ForgotUserName;
